export default {
      id: "help__add_car_icon-usage",
      viewBox: "20 0 55.69 67.18",
      url: __webpack_public_path__ + "img/icons.svg#help__add_car_icon",
      toString: function () {
        return this.url;
      }
    }